// Demo portfolio — fleet-generated example sites (all business names fictional).
// Screenshots live in /public/demos/. Live sites are throwaway Netlify deploys.

export const DEMO_SITES = [
  {
    slug: 'medspa',
    business: 'Luminara Med Spa',
    industry: 'Med Spa',
    url: 'https://gn-demo-medspa.netlify.app',
    img: '/demos/medspa.jpg',
  },
  {
    slug: 'landscaper',
    business: 'Stonebrook Landscaping Co.',
    industry: 'Landscaping',
    url: 'https://gn-demo-landscaper.netlify.app',
    img: '/demos/landscaper.jpg',
  },
  {
    slug: 'gym',
    business: 'Ironhawk Fitness Club',
    industry: 'Gym & Fitness',
    url: 'https://gn-demo-gym.netlify.app',
    img: '/demos/gym.jpg',
  },
  {
    slug: 'photographer',
    business: 'Aperture Lane Photography',
    industry: 'Photography',
    url: 'https://gn-demo-photographer.netlify.app',
    img: '/demos/photographer.jpg',
  },
  {
    slug: 'restaurant',
    business: 'Saffron & Sage Bistro',
    industry: 'Restaurant',
    url: 'https://gn-demo-restaurant.netlify.app',
    img: '/demos/restaurant.jpg',
  },
  {
    slug: 'wedding',
    business: 'Everly Rose Events',
    industry: 'Wedding Vendor',
    url: 'https://gn-demo-wedding.netlify.app',
    img: '/demos/wedding.jpg',
  },
];

// Done-for-you service offer — single source of truth for the $199 positioning.
export const OFFER = {
  price: 199,
  anchorPrice: 299,
  foundingSpots: 10,
  payhipUrl: 'https://shop.globalnow.biz/b/vhFEZ',
  phoneDisplay: '(407) 706-8990',
  phoneTel: '+14077068990',
};
